export enum ProductLine {
  Windows = 'windows',
}

export enum SourceType {
  Youtube = 'youtube',
  Facebook = 'social',
  Google = 'google',
  Email = 'email',
  Quora = 'quora',
  Bing = 'bing',
}

export enum SourceName {
  Gclid = 'gclid',
  Gbraid = 'gbraid',
  Wbraid = 'wbraid',
  Fbclid = 'fbclid',
  Msclkid = 'msclkid',
}

export enum OriginHost {
  Top10HomeServices = 'top10homeservices.com',
}
